import axiosInstance from 'services/axiosMiddleware';

export async function coachSupport(coachData) {
  try {
    const response = await axiosInstance.post('support/coachQuery', coachData);

    if (response.data.status) {
      return response.data; // Return full response or just response.data.data as needed
    } else {
      throw new Error(response.data.message);
    }
  } catch (error) {
    console.error('Error sending coach query:', error);
    throw new Error(error?.response?.data?.message || 'Failed to send support query');
  }
}
